import { sortBy } from 'lodash/fp';

import { Check, CheckStatus } from 'dashboard/models/check';

/**
 * Sort checks by requirement and status.
 */
export function sortChecks(checks: Check[]): Check[] {
  return sortBy(
    (check: Check) => [
      check.requirement === 'required' ? 0 : 1,
      check.status === CheckStatus.Failed ? 0 : check.status === CheckStatus.Passed ? 1 : 2,
    ],
    checks,
  );
}
